module.exports = __webpack_public_path__ + "img/list_9_tc.a95a36ae.png";